/**
 * Zahlungsstand of an issued Privatrechnung (CONTEXT.md, ADR-0043). Derived by
 * the aggregate from its Zahlungen and Ausbuchung — never set by hand.
 *
 * - Offen → `OPEN`
 * - Teilweise bezahlt → `PARTIALLY_PAID`
 * - Bezahlt → `PAID`
 * - Ausgebucht → `WRITTEN_OFF`
 */
export var PatientInvoiceSettlement;
(function (PatientInvoiceSettlement) {
    PatientInvoiceSettlement["OPEN"] = "open";
    PatientInvoiceSettlement["PARTIALLY_PAID"] = "partially_paid";
    PatientInvoiceSettlement["PAID"] = "paid";
    PatientInvoiceSettlement["WRITTEN_OFF"] = "written_off";
})(PatientInvoiceSettlement || (PatientInvoiceSettlement = {}));
/** Settlement values under which an issued invoice still counts as offen. */
export const OPEN_SETTLEMENTS = [
    PatientInvoiceSettlement.OPEN,
    PatientInvoiceSettlement.PARTIALLY_PAID,
];
//# sourceMappingURL=patient-invoice-settlement.enum.js.map